import { E_ActionType } from "@backend/graph/patients/patient-base";
import { E_Patient_Actions_Type } from "@backend/graph/patient_actions/patient-action-base";

type CountryCode = "EN" | "WA" | "NI" | "IE" | "SC" | "CA" | "AU" | "NZ";
type CountryConfig = {
  nhsFormAction?: E_ActionType;
  requireNhsNumber: boolean;
  supportsNhsPr: boolean;
  /**
   * Actions that are independent of each other and will not change the required status of other actions after completion
   */
  independentActions: E_Patient_Actions_Type[];
};

const _countryConfig: Partial<Record<CountryCode, Partial<CountryConfig>>> & Record<"default", CountryConfig> = {
  EN: {
    requireNhsNumber: true,
    supportsNhsPr: true,
    nhsFormAction: E_ActionType.FP17,
    independentActions: [E_Patient_Actions_Type.NHS_PR, E_Patient_Actions_Type.PATIENT_DETAILS, E_Patient_Actions_Type.MEDICAL_HISTORY],
  },
  WA: {
    requireNhsNumber: true,
    supportsNhsPr: true,
    nhsFormAction: E_ActionType.FP17,
    independentActions: [E_Patient_Actions_Type.NHS_PR, E_Patient_Actions_Type.PATIENT_DETAILS, E_Patient_Actions_Type.MEDICAL_HISTORY],
  },
  SC: {
    supportsNhsPr: true,
    nhsFormAction: E_ActionType.GP17Part1,
  },
  default: {
    requireNhsNumber: false,
    supportsNhsPr: false,
    independentActions: [E_Patient_Actions_Type.PATIENT_DETAILS, E_Patient_Actions_Type.MEDICAL_HISTORY],
  },
};

export function getCountryConfig(code: string): CountryConfig {
  return { ..._countryConfig.default, ..._countryConfig[code] };
}
